import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import '../css/Header.css';
import '../css/ContactInfo.css';
import { FaShoppingCart, FaBars, FaTimes } from 'react-icons/fa';
import logo from '../assets/images/logo.jpg';
import Cart from './Cart';
import SearchBar from "./SearchBar";
import { COMPANY_PHONES } from '../config';
import { useCart } from '../context/CartContext';
import CopyPhoneText from './CopyPhoneText';

const UnifiedHeader = () => {
    const [isMenuOpen, setIsMenuOpen] = useState(false);
    const {
        cartItems = [],
        isCartOpen,
        setIsCartOpen,
        removeFromCart,
        updateQuantity
    } = useCart();

    const toggleMenu = () => {
        setIsMenuOpen(!isMenuOpen);
    };

    const toggleCart = (e) => {
        e.preventDefault();
        setIsCartOpen(!isCartOpen);
    };

    // Блокуємо прокрутку body, коли меню відкрите
    useEffect(() => {
        if (isMenuOpen) {
            // Зберігаємо поточну позицію прокрутки
            const scrollY = window.scrollY;
            document.body.style.overflow = 'hidden';
            document.body.style.position = 'fixed';
            document.body.style.top = `-${scrollY}px`;
            document.body.style.width = '100%';
            document.body.style.left = '0';
            document.body.style.right = '0';
        } else {
            // Відновлюємо прокрутку
            const scrollY = document.body.style.top;
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.left = '';
            document.body.style.right = '';
            if (scrollY) {
                window.scrollTo(0, parseInt(scrollY || '0') * -1);
            }
        }

        // Cleanup функція для гарантованого відновлення стилів
        return () => {
            document.body.style.overflow = '';
            document.body.style.position = '';
            document.body.style.top = '';
            document.body.style.width = '';
            document.body.style.left = '';
            document.body.style.right = '';
        };
    }, [isMenuOpen]);

    return (
        <>
            {/* Overlay для мобільного меню */}
            <div 
                className={`menu-overlay ${isMenuOpen ? 'active' : ''}`} 
                onClick={() => setIsMenuOpen(false)}
            />

            {/* Основний хедер з навігацією */}
            <header className="main-header">
                <div className="logo">
                    <a href="/">
                        <img src={logo} alt="Logo" className="header-logo"/>
                    </a>
                </div>

                {/* Посилання в навігації (видно на мобільних при відкритому меню) */}
                <nav className={`nav-links ${isMenuOpen ? 'active' : ''}`}>
                    <Link to="/zapchastyny" onClick={() => setIsMenuOpen(false)}>Товари та послуги</Link>
                    <Link to="/contacts" onClick={() => setIsMenuOpen(false)}>Контакти</Link>
                    <Link to="/about" onClick={() => setIsMenuOpen(false)}>Про нас</Link>

                    {/* Dropdown "Покупцям" — десктоп: hover, мобільний: flat */}
                    <div className="nav-dropdown">
                        <span className="nav-dropdown__trigger">
                            Покупцям <span className="nav-dropdown__arrow">▾</span>
                        </span>
                        <div className="nav-dropdown__menu">
                            <Link to="/reviews" onClick={() => setIsMenuOpen(false)}>Відгуки</Link>
                            <Link to="/return-policy" onClick={() => setIsMenuOpen(false)}>Гарантія та повернення</Link>
                            <Link to="/payment" onClick={() => setIsMenuOpen(false)}>Оплата та доставка</Link>
                        </div>
                    </div>

                    {/* Мобільний варіант — flat посилання без dropdown */}
                    <div className="nav-dropdown-mobile">
                        <span className="nav-dropdown-mobile__label">Покупцям</span>
                        <Link to="/reviews" onClick={() => setIsMenuOpen(false)}>— Відгуки</Link>
                        <Link to="/return-policy" onClick={() => setIsMenuOpen(false)}>— Гарантія та повернення</Link>
                        <Link to="/payment" onClick={() => setIsMenuOpen(false)}>— Оплата та доставка</Link>
                    </div>

                    <Link
                        to="/vin-search"
                        className="nav-link-vin"
                        onClick={() => setIsMenuOpen(false)}
                    >
                        🔍 Підбір за VIN кодом
                    </Link>
                    {/* Посилання на "Корзину" – лише для мобільного меню */}
                    <a href="/cart" className="cart-mobile-link" onClick={(e) => { toggleCart(e); setIsMenuOpen(false); }}>
                        <FaShoppingCart />
                        <span>Корзина</span>
                        {cartItems?.length > 0 && (
                            <span className="cart-count">{cartItems.length}</span>
                        )}
                    </a>
                </nav>

                {/* VIN кнопка — видима в хедері тільки на мобільних */}
                <Link
                    to="/vin-search"
                    className="vin-header-mobile-btn"
                >
                    🔍 Підбір по VIN
                </Link>

                <div className="menu-icon" onClick={toggleMenu}>
                    {isMenuOpen ? <FaTimes size={24} /> : <FaBars size={24} />}
                </div>

                {/* Іконка "Корзини" – лише для десктопу */}
                <div className="cart-icon">
                    <a href="/cart" onClick={toggleCart}>
                        <FaShoppingCart size={24} />
                        {cartItems?.length > 0 && (
                            <span className="cart-count">{cartItems.length}</span>
                        )}
                    </a>
                </div>
            </header>

            {/* Контактна інформація з пошуком - частина хедера */}
            <div className="contact-info">
                {/* Блок із назвою, адресою - ліворуч */}
                <div className="contact-details">
                    <h2 className="contact-title">Union Auto</h2>
                </div>

                {/* Блок із пошуком (SearchBar) - в центрі */}
                <div className="search-bar-container">
                    <SearchBar />
                </div>

                {/* Блок із телефонами - праворуч */}
                <div className="contact-phones">
                    {COMPANY_PHONES.map(({ number, display }, index) => (
                        <p key={number} className={index === 2 ? 'contact-phone-row' : undefined}>
                            <CopyPhoneText number={number} className="contact-phone">
                                {display}
                            </CopyPhoneText>
                        </p>
                    ))}
                </div>
            </div>

            <Cart
                isOpen={isCartOpen}
                onClose={() => setIsCartOpen(false)}
                items={cartItems}
                onRemoveItem={removeFromCart}
                onUpdateQuantity={updateQuantity}
            />
        </>
    );
};

export default UnifiedHeader;
